import lang from "element-ui/lib/locale/lang/en"; // 引入element语言包
export default {
  ...lang,
  failed: "fail",
  关闭弹窗: "Close",
  我知道了: "Got it",
  success: "success",
  暂未开通功能: "The function is being debugged, please look forward to the launch soon.",
  "功能正在研发中...": "The function is being debugged, please look forward to the launch soon.",
  服务: "SERVICE",
  服务介绍: "Service Introduction",
  国际运输: "International Courier",
  合作意向: "Be a Customer",
  首页: "HOME",
  VIEW: "VIEW",
  "Expand More": "Expand More",
  关于我们: "ABOUT J&T",
  帮助中心: "HELP CENTER",
  公司简介: "About Us",
  加入我们: "Join Us",
  网点查询: "Services Points",
  输入您的电子邮件或手机号: "Enter your email or phone number",
  "contact us": "CONTACT US",
  "12 Countries’ Official Websites": "8 COUNTRIES OFFICIAL WEBSITES",
  "J&T Express exclusive APP": "J&T EXPRESS EXCLUSIVE APP",
  "J&T Express exclusive APP One-click order, real-time query, worry-free delivery, express surprise":
    "J&T Express exclusive APP One-click order, real-time query, worry-free delivery, express surprise",
  CHINA: "CHINA",
  SINGAPORE: "SINGAPORE",
  CAMBODIA: "CAMBODIA",
  THAILAND: "THAILAND",
  PHILIPPINES: "PHILIPPINES",
  MALAYSIA: "MALAYSIA",
  VIETNAM: "VIETNAM",
  INDONESIA: "INDONESIA",
  ARABIA: "SAUDI ARABIA",
  UAE: "UAE",
  EGYPT: "EGYPT",
  MEXICO: "MEXICO",
  BRAZIL: "BRAZIL",
  "999开头的及J开头的单号查询": "Only order starting with 999 and J are provided by now",

  pageIndex: {
    searchPlaceholder: "Please enter your waybill number to track the shipment status in real time",
    onlineMail: "Online Fast Order",
    Inquires: "INQUIRIES",
    ShippingRates: "Manda fácil",
    TransitTime: "Transit Time",
    ServicePoints: "Services Points",
    ServiceCoverage: "Services Coverage",
    Address: "***,***,***,******",
    phone: "***-****-****",
    email: "meajuda@jtexpress.com.br",
    税号: "CPF//CNPJ",
    税号不能为空: "CPF/CNPJ cannot be empty",
    "CPF/CNPJ为11~14位数字": "CPF/CNPJ consists of 11 to 14 digits",
    "对不起，没有找到该订单的信息": "Sorry, the information for this order was not found",
    请确认订单号是正确的: ". Confirm the order number is correct.",
  },
  pageOnlineOrder: {
    请完善地址信息: "Please complete the address",
    我们将上门取件: "We will pickup at door",
    寄件人信息: "Sender Info.",
    从通讯录选择: "Select from address book",
    清空: "Empty",
    添加到通讯录: "Add to address book",
    省市区: "省市区",
    详细地址: "详细地址",
    详细地址1: "Address1",
    详细地址2: "Address2",
    收件人信息: "Receiver Info.",
    物品信息: "Item info.",
    物品类型: "Item type",
    物品名称: "Item name",
    结算方式: "Payment method",
    物品重量: "物品重量",
    备注: "Notes",
    下单: "Order",
    寄件地址与收件地址不能相同: `Sender's address cannot be the same as receiver's address`,
    "预估费用(不含税)": "预估费用(不含税)",
    "预估费用(含税)": "Estimated cost (including tax)",
    预估费用: "Estimated cost",
    最终运费以收派员为准: "最终运费以收派员为准",
    立即下单: "立即下单",
    下单成功: "Order successfully",
    业务员正在快马加鞭赶过来: "Courier is rushing to the sender address, please keep the phone on",
    订单号: "Order No.",
    复制: "Copy",
    关闭: "Close",
    查看订单: "View",
    产品类型: "Product type",
    请选择产品类型: "Please choose product type",
    姓名: "Name",
    手机号: "Phone number",
    请输入手机号: "Please enter phone number",
    手机号码: "Phone number",
    请输入姓名: "Please enter name",
    请输入手机号码: "Please enter phone number",
    请输入详细地址: "Please enter address",
    请选择物品类型: "Please choose item type",
    请输入物品名称: "Please enter item name",
    请选择付款方式: "Please select payment method",
    请输入物品重量: "Please enter item weight",
    请输入备注: "Please enter notes",
    寄付现结: "PP_cash",
    到付现结: "Cash on delivery",
    点击填写寄件人信息: "Click to fill sender Info.",
    点击填写收件人信息: "Click to fill receiver Info.",
    邮箱: "E-mail",
    省份: "省份",
    州: "State",
    请选择省份: "请选择省份",
    请选择州: "Please choose state",
    城市: "City",
    市: "City",
    请选择城市: "Please choose city",
    乡镇: "Township",
    请选择乡镇: "Please select a town",
    街道: "Street",
    请输入街道: "Please enter the street",
    支付方式: "支付方式",
    "体积(CM)": "体积(CM)",
    体积: "体积(CM)",
    信息查询: "信息查询",
    运单号不能为空: "Tracking number cannot be empty",
    查询: "Search",
    寄件地址簿: "Sender address",
    收件地址簿: "Destination address",
    手机: "Phone number",
    地址: "Address",
    联系人: "Name",
    选择联系人: "Select address",
    现金: "现金",
    长: "long",
    宽: "width",
    高: "height",
    "以上运费不含燃油附加费和增值税，具体标准以当地门店的标准为准":
      "The above freight does not include fuel surcharge and value-added tax. The specific standard is subject to the standard of the local store.",
    未查询到运费金额: "Cannot query the total amount, please contact Hotline to check",
    保存: "Save",
    预估运费: "预估运费",
    单边长度不超过158cm: "The length of each side cannot exceed 158cm",
    长宽高三边长度之和不超274cm: "The sum of length, width and height shall not exceed 274cm",
    "勾选体积时，长宽高皆不可为空": "勾选体积时，长宽高皆不可为空",
    "0＜重量≤30KG，1位小数": "0＜weight ≤30KG， 1 decimals",
    长度不超过20个字符: "长度不超过20个字符",
    长度不超过30个字符: "长度不超过30个字符",
    长度不超过50个字符: "长度不超过50个字符",
    长度不超过200个字符: "长度不超过200个字符",
    请输入正确的邮箱: "Please enter valid email address",
    请输入正确的手机号: "Please enter valid phone number",
    请选择支付方式: "Please choose mode of payment",
    请选择结算方式: "Please select payment method",
    确认修改: "Confirm",
    公司名称: "Company name",
    请输入公司名称: "Please enter company name",
    邮编: "Zip code",
    请输入邮编: "Please enter the zip code first",
    请输入邮编获取: "Please enter zip code",
    "净重(kg)": "Net weight",
    "包裹重(kg)": "Package weight",
    结算方式说明: "PP_CASH：PP_cash；<br>CC_CASH：Cash on deliver; <br>PP_PM：Monthly settlement",
  },
  networkSelect: {
    请输入邮编: "Please enter the zip code first",
    服务网点: "Services Points",
    查询: "inquiry",
    暂无数据: "No data",
    导航: "Navigation",
    快递时效: "Transit Time",
    运单费用: "Shipping rates",
    收寄范围: "Services Coverage",
    收件网点: "collection outlet",
    派件网点: "delivery outlet",
    总条数Msg: "{} outlets have been found",
    "州/市": "State/City",
    "网点正在努力开发中！": "The site is under development!",
    请输入有效邮编: "Please enter a valid email",
    "您检索的邮编可能有误，验证后重试。": "The zip code you retrieved may be incorrect, verify it and try again.",
  },
  pagePublicServe: {
    info: "J&T Express offers door-to-door standard pick-up and delivery services for you to deliver e-commence parcels from 0 to 30 kilograms nationwide. We also provide you with integrated logistics solutions.",
    expressDeliveryService: "J&T Express provides you with 7×24 hours, 365 days express delivery service to meet your needs anytime and anywhere.",
    "365DaysService": "365 DAYS SERVICE",
    "24HOURS": "7×24 HOURS",
    FastResponse: "J&T Express makes every effort to provide quick feedback on solutions to customer needs.",
    PersonalizedServices:
      "Customized and personalized VIP service solutions are provided for VIP customers with higher security and timeliness needs, freeing you from all worries.",
    VipService: "VIP SERVICE",
    personalized: "PERSONALZED",
    customized: "CUSTOMIZED",
    TraceTrack: "You can track the shipment status through J&T Express website and mobile APP.",
    "E-commercePartners":
      "J&T Express has established partnerships with major E-commerce platforms in the country to provide safe and reliable logistics services to E-commerce customers.",
  },
  "365 DAYS OF OPERATION": "365 DAYS OF OPERATION",
  "FAST RESPONSE": "FAST RESPONSE",
  "PERSONALIZED SERVICES": "PERSONALZED SERVICES",
  "TRACE & TRACK": "TRACE & TRACK",
  "E-commerce Partners": "E-COMMERCE PARTNERS",
  "About Us": "ABOUT US",
  "Who Are We": "Who Are We",
  "WHO ARE WE": "WHO ARE WE",
  "Business Culture": "Corporate Culture",
  "BUSINESS CULTURE": "CORPORATE CULTURE",
  "Brand Strength": "Brand Strength",
  "BRAND STRENGTH": "BRAND STRENGTH",
  "Brand History": "Brand History",
  "BRAND HISTORY": "BRAND HISTORY",
  Mission: "Mission",
  Vision: "Vision",
  "Core Values": "Core value",
  pageAboutUs: {
    WhoAreWe: `J&T Express is committed to become a reliable integrated logistics service provider using a globally scientifical and technological innovation capacity to constantly bring our customers best delivery services.`,
    Mission: "Customer-focused and efficiency-based",
    Vision: "To be a healthy and long-lasting company",
    Core: `"Benfen", Sharing, Responsibility`,
    BrandStrength_one:
      "J&T Express provides diverse services including express delivery, express transportation, warehousing and supply chain, which cover intra-city, inter-province and globe. Our service network has reached nearly 2.5 billion people worldwide.",
    BrandStrength:
      "We have more than 240 distribution centers, 600 intelligent sorting equipment, 10000 selfowned vehicles, over 23,000 service points and more than 400,000 service providers.",
    BrandHistory: `J&T Express was founded in 2015. As for now, our service network has covered 13 countries worldwide. We committed to provide high-quality, efficient, stable and reliable logistics services for customers every day, so that more people around the world can enjoy the convenience of E-commerce era.`,
  },
  "June 2021": "June 2021",
  "J&T Express USE, Saudi Arabia, Brazil, Mexico, Egypt officially launched": "J&T Express UAE, Saudi Arabia, Brazil, Mexico, Egypt in preparation",
  "March 2020": "March 2020",
  "J&T Express China officially established": "J&T Express China officially established",
  "January 2020": "January 2020",
  "J&T Express Singapore officially established": "J&T Express Singapore officially established",
  "October 2019": "October 2019",
  "J&T Express Cambodia officially established": "J&T Express Cambodia officially established",
  "March 2019": "March 2019",
  "J&T Express Thailand was officially established": "J&T Express Thailand officially established",
  "J&T Express Philippines officially established": "J&T Express Philippines officially established",
  "August 2018": "August 2018",
  "J&T Express Malaysia officially established": "J&T Express Malaysia officially established",
  "July 2018": "July 2018",
  "J&T Express Vietnam officially established": "J&T Express Vietnam officially established",
  "October 2017": "October 2017",
  October2017History: `The strategy conference “Express Your Online Business” was held, marking J&T Group's entry into the era of E-commerce express delivery`,
  "August 2015": "August 2015",
  "J&T Express Indonesia officially established": "J&T Express Indonesia officially established",
  "BE TOGETHER BETTER FUTURE": "BE TOGETHER BETTER FUTURE",
  "JOIN US": "JOIN US",
  joinUsInfo: `The talents are our most precious fortune. Advocating the core value of Ben Fen, J&T Express has fostered a cultural atmosphere of “Be together, better future”. We encourage internal sharing, and always adhere to providing an equal, diverse and inclusive working environment for employees. Different genders, nationalities, ethnics and religions of our employees are all fully respected. Through a comprehensive training system and a unique co-partnership system, J&T express can provide employees with a career path to a better future.`,
  "EXPLORE POSITIONS": "EXPLORE POSITIONS",
  "More great jobs coming soon…": "More great jobs coming soon…",
  "RECRUITMENT E-MAIL": "RECRUITMENT E-MAIL",
  pageTrajectoryQuery: {
    单号列表: "Waybill list",
    运单信息: "Waybill Info",
    无效运单号: "Invalid tracking number",
    运单号Msg: "Sorry, the tracking number {} is invalid, please check again",
    存在非法运单号: "There are invalid tracking numbers",
    查询: "Inquire",
    运单列表: "Waybill list",
    运单详情: "Waybill detail",
    快件跟踪: "Waybill tracking",
    运单号不能为空: "Tracking number cannot be empty",
    单号长度超限: "Each number cannot exceed 44 characters",
    单次最多查询30条运单号: "You can query up to 30 numbers at a time",
    运单号: "Tracking No",
    searchPlaceholder2: "You can enter up to 10 tracking numbers, which separated by comma or semicolons",
    安全提醒:
      "Security alert: J&T Express does not request payment of customs fees via WhatsApp/SMS/third-party links for the delivery of your package. For any charges or delivery updates, use only the official channels of J&T Express.",
    收件人信息确认: "Recipient Information Confirmation",
    "收件人CNPJ/CPF": "Recipient CPF/CNPJ",
    收件人CEP: "Recipient Postal Code (CEP)",
    校验: "Verification",
    "请输入收寄件人CPF/CNPJ": "Please enter the sender/recipient's CPF/CNPJ. ",
  },
  信息: "INFORMATION",
  隐私政策: "Privacy Policies",
  关注我们: "FOLLOW US",
  其他市场官网: "Explore our websites in other markets",
  "关于 J&T EXPRESS": "ABOUT J&T",
  中国大陆: "Chinese Mainland",
  中国香港: "Hong Kong, China",
  印度尼西亚: "Indonesia",
  马来西亚: "Malaysia",
  菲律宾: "Philippines",
  新加坡: "Singapore",
  柬埔寨: "Cambodia",
  泰国: "Thailand",
  越南: "Vietnam",
  沙特阿拉伯: "Saudi Arabia",
  阿拉伯联合酋长国: "UAE",
  墨西哥: "Mexico",
  埃及: "Egypt",
  营业时间: "BUSINESS HOURS",
  "上午8:00 - 晚上6:00": "8:00 AM -  6:00 PM ",
  "周一至周四  —— 08h - 18h": "Monday to Thursday —— 08h - 18h",
  "周五至周六  —— 08h - 17h": "Friday to Saturday —— 08h - 17h",
  预计签收时间: "Plan receipt time",
  查看图片: "View Image",
  预览图片: "Preview Image",
  网点类型: "Network type",
  收件网点: "collection",
  派件网点: "delivery",
  "在这里模拟您的配送，找到运往巴西各地的最佳运费": "Simulating your shipments here and find the best shipping prices to anywhere in Brazil!",
  始发地邮编: "Origin ZIP code",
  目的地邮编: "Destination ZIP code",
  高: "Height",
  宽: "Width",
  长: "Length",
  重量: "Weights",
  货物价值: "Value",
  计算运费: "Calculate shipping",
  清空: "Back",
  寄件网点: "Drop Point",
  "仅供参考，根据实际情况可能会有变动": "For reference only, subject to changes based on the actual situation.",
  最大30公斤: "Máx. 30kg",
  "0-120cm": "Each side must not exceed 120cm",
  "R$ 0 - 1000": "R$ 0 - 1000",
  无效邮编: "The provided ZIP code is invalid",
  含税金额: "Including Taxes",

  登录: "Login",
  注册: "Register",
  个人中心: "Personal Center",
  退出登录: "Logout",
  输入您的电子邮件或电话号码: "Enter your email or phone number",
  请输入密码: "Enter your password",
  立即注册: "Register now",
  忘记密码: "Forgot password",
  登录成功: "Login successful",
  姓名: "Name",
  电话: "Phone",
  验证码已通过电子邮件发送: "Verification code sent via email",
  验证码: "Verification code",
  获取验证码: "Get verification code",
  密码: "Password",
  确认密码: "Confirm password",
  确认: "Confirm",
  "已有账号，去登录": "Already have an account, go to login",
  我已阅读并接受: "I have read and accept",
  使用条款: "Terms of use",
  隐私协议: "Privacy policy",
  "密码格式为6~16位大小写字母加数字": "Password must be 6-16 characters, with letters and numbers",
  密码不一致: "Passwords do not match",
  邮箱格式不正确: "Incorrect email format",
  请输入姓名: "Please enter your name",
  请输入电话号码: "Please enter your phone number",
  请输入CPF或CNPJ: "Please enter CPF or CNPJ",
  CPF或CNPJ: "CPF or CNPJ",
  请输入验证码: "Please enter the verification code",
  长度在8到14位: "Length between 8 and 14 characters",
  注册成功: "Registration successful",
  找回密码: "Retrieve password",
  请输入您的邮箱: "Please enter your email",
  再次输入密码: "Re-enter password",
  返回: "Return",
  密码修改成功: "Password changed successfully",
  手机号: "Phone number",
  邮箱: "E-mail",
  请输入邮箱: "Please enter your email",
  和: " and ",
  我要寄件: "Create order",
  运费查询: "Order cost",
  轨迹查询: "Check tracking",
  我的订单: "Order list",
  订单列表: "Order list",
  联系客服: "Customer Support",
  我的数据: "My data",
  清除数据: "Clear data",
  "%天送达": "Delivery in % days",
  预测: "Forecast",
  将于以下日期到达: "Will arrive on",
  发送: "Send",
  欢迎: "Welcome",
  下单日期: "Order creation date",
  订单号: "Order number",
  运单号: "Waybill Number",
  运费: "Freight",
  订单状态: "Order status",
  面单: "Label",
  点击下载: "Click to download",
  下载中: "Downloading",
  物品金额: "Item amount",
  立即下单: "Create order now",
  物品信息: "Item Information",
  物品名称: "Item Name",
  请输入物品名称: "Please enter the item name",
  本人声明此处描述的所有内容均属真实: "I hereby declare that all the information described here is true",
  寄件人: "Sender",
  "请输入CNPJ/CPF": "Please enter CNPJ/CPF",
  寄件人姓名: "Sender's Name",
  请输入寄件人姓名: "Please enter the sender's name",
  请输入手机号: "Please enter your mobile number",
  请输入电话: "Please enter your phone number",
  邮编: "Postal Code",
  请输入邮编: "Please enter the postal code",
  详细地址: "Detailed Address",
  请输入详细地址: "Please enter the detailed address",
  街道号: "Street No.",
  请输入街道号: "Please enter the street number",
  街道: "Street",
  请输入街道: "Please enter the street",
  区: "District",
  省: "State",
  市: "City",
  请输入IE: "Please enter IE",
  选择取件网点: "Select Pickup Location",
  取件网点名称: "Pickup Location Name",
  收件人: "Recipient",
  确定: "Confirm",
  请输入高: "Please enter height",
  请输入宽: "Please enter width",
  请输入长: "Please enter length",
  请输入重量: "Please enter weight",
  请输入货物价值: "Please enter item value",
  请输入邮编获取省市区: "Please enter the postal code to obtain the state, city and district",
  "长度为11-14位": "Length must be 11-14 characters",
  "长度为8-14位": "Length must be 8-14 characters",
  长度为8位: "Length must be 8 characters",
  "长度为2-200位": "Length must be 2-200 characters",
  请选择取件网点: "Please select the pickup location",
  订单已确认: "Order confirmed",
  "您的面单将通过电子邮件发送，附带邮寄指南。": "Your label will be sent via email along with shipping instructions.",
  订单详情: "Order Details",
  继续下单: "Continue creating order",
  在搜索栏中输入邮编查询: "Enter the postal code in the search bar to find",
  搜索: "Search",
  距离: "Distance",
  选择: "Select",
  收件人姓名: `Recipient's name`,
  请输入收件人姓名: `Please enter recipient's name`,
  电话号码格式不正确: "Incorrect phone number format",
  轨迹跟踪: "Tracking",
  查看全部: "View all",
  详情: "Details",
  ies: {
    国际运输服务: "International<br/> Courier",
    提供全程追踪服务: "Intelligent and Cost-Effective International Courier",
    智能且高性价比的国际运输解决方案: " Solutions with Complete Tracking at Every Stage!",
    简介: "We are here to simplify your cross-border shipping operations to Brazil! With comprehensive and accessible solutions, you can put your worries about bureaucracy and deadlines aside. We offer flexible solutions tailored to your needs, including full “door-to-door” logistics or customized step-by-step services:",
    为什么: "Why Choose J&T Express Courier for Your International Shipments?",
    便捷: "Simplicity: ",
    便捷说明: "We eliminate complexity by handling all the details for you. ",
    经济: "Cost-Effectiveness: ",
    经济说明: "Our solutions are intelligent and economical, saving you both time and money.  ",
    可靠: "Reliability: ",
    可靠说明: "Rely on our expertise to ensure that your shipments arrive at their destination without any issues.",
    我们为您的业务提供多种解决方案: "We offer a variety of solutions<br/> for your business.",
    我们的专业领域: "Our Areas of Operation:",
    了解更多: "Learn more",
    电子商务: "E-commerce",
    电子商务说明开头: "Count on our expertise",
    电子商务说明:
      " to send and receive products for your e-commerce. Through our own network and partners worldwide, we will manage the entire process for you. From order collection to shipment to Brazil, including customs clearance, we handle every step. This means you can leave the bureaucracy to us and focus more on your sales and business growth. We simplify logistics so you can reach new heights of success in the world of e-commerce.",
    国际货物运输: "International<br/> Shipments",
    国际货物运输说明开头: "At J&T Express Courier, ",
    国际货物运输说明:
      "we are committed to making the importation of goods simpler and more efficient for you. Our international shipment services are specifically designed to meet your import needs, with a particular focus on courier services, offering speed, reliability, compliance with regulations, transparency, and traceability, all while saving you time and money.",
    货物合规运输计划: "Compliance Shipment Program (PRC)",
    货物合规运输计划1: "Compliance Shipment Program (PRC)",
    货物合规运输计划说明开头: "Certification in the Compliance Shipment Program (PRC) ",
    货物合规运输计划说明:
      "by the Federal Revenue Service allows e-commerce companies to obtain tax and customs benefits for goods they sell and ship to Brazil through international shipments supported by the Simplified Taxation Regime. These benefits include a zero rate for the Import Tax when the value of the goods in shipments destined for individuals is up to $50, or its equivalent in another currency. Additionally, these shipments are prioritized in customs clearance.  ",
    更多: "For more details, ",
    请访问: "please visit the portal: ",
    客服: "Still have outstanding debts? Please contact the J&T Express Help Center, and we will be pleased to assist you.",
    样品寄送: "Samples",
    样品寄送说明开头: "If you need to send or receive",
    样品寄送说明:
      " product samples from clients or partners abroad, we are here to make the process easy and cost-effective. Our international shipment services for samples with no commercial value ensure that your samples reach their destination quickly and safely, complying with all customs regulations.",
    规则: "Rules",
    规则说明:
      "Rules:<br/>- Simplified process, without the need for RADAR or a customs broker.<br/>- The value of the goods must not exceed the limit of $3,000.00 (three thousand U.S. dollars), or its equivalent in another currency.<br/>- Legal entities with or without commercial purposes (for goods intended for resale up to the limit of $150,000.00 in the calendar year).<br/>- Individuals without commercial purposes (importing goods or packages in quantities and frequencies that characterize commerce by individuals is not permitted).<br/>- Mandatory information must be provided in advance by the carrier (e.g., Tax ID, Name, Address, etc.), failure to do so may result in the inability to complete clearance and the return of the goods to the origin, with costs borne by the shipper. Refer to Normative Instruction RFB No. 2124, dated December 16, 2022.<br/>- Weight limit per package is 30 kg.<br/>- Dimensions for non-invasive inspections are limited to 90 cm x 100 cm.<br/>- Must be accompanied by a commercial invoice.<br/>- Keep documents related to import/export in proper order as stipulated in Article 70 of Law No. 10,833 dated December 29, 2003.<br/>- In the case of pending issues, the retention period is up to 20 days after arrival, with the risk of goods being returned if the situation is not regularized.",
    征税制度: "Regime",
    征税制度说明:
      "Regime:<br/>The Simplified Taxation Regime applies a single import tax (II) rate of 60% regardless of the tariff classification, plus ICMS of the recipient's state of residence, calculated on the CIF value plus II. Exemption from IPI, PIS, and COFINS.<br/><br/>Compliance Shipment Program:<br/>The Import Tax rate will only apply to international shipments:<br/>- Purchased from e-commerce companies certified in the Compliance Shipment Program. Please consult the list of certified companies.<br/>- For goods valued up to $50.00 (or equivalent), the import tax will be 20%.<br/>- For goods valued over $50.01 (or equivalent), the import tax will be 60%, with a discount of $20 on the calculated tax amount.<br/>- Applicable only to individual buyers.<br/>- With advance payment of 17% ICMS.  For international shipments that do not meet all the above requirements, the general rate under the simplified taxation regime remains at 60% (+ ICMS of the recipient's state of residence).<br/><br/>Imported Medications by Individuals<br/>The value limit for the importation by individuals of finished products belonging to the category of medications will be $10,000.00 (ten thousand U.S. dollars), subject to the requirements and conditions established in Ministry of Finance Ordinance No. 156, dated June 24, 1999, and the provisions of § 7. (As amended by Normative Instruction RFB No. 2208, dated July 31, 2024).<br/>If the total customs value of the shipment referred to in § 6 exceeds the limit defined in Article 37, caput, importation will only be permitted if the shipment contains exclusively finished products belonging to the category of medications. (Included by Normative Instruction RFB No. 2208, dated July 31, 2024).<br/>The release of these products is conditional upon compliance with the requirements established by the National Health Surveillance Agency (ANVISA), the administrative control body.<br/><br/>It is important to note that this benefit applies only to medications intended for personal use by individuals (understood as being imported by one individual for the treatment of another individual, such as a parent importing medication for their child). The benefit does not cover the importation of medications intended for veterinary use, supplements, or cosmetics.<br/><br/>Unaccompanied Baggage<br/>Unaccompanied baggage treatment may be granted upon request for goods contained in international shipments coming from a country where the traveler has stayed or resided.  <br/>To be considered unaccompanied baggage, the international shipment must originate from the location or one of the locations of stay or origin of the traveler and must arrive in the country within 3 months prior to or up to 6 months after the traveler's arrival.  <br/>The items included in unaccompanied baggage will not be subject to taxation in the following cases:  <br/>- Return of national or nationalized goods;  <br/>- Used clothing and personal items, as well as books, brochures, and periodicals;  <br/>- Goods, whether new or used, listed in Article 35 of Normative Instruction RFB No. 1,059/2010, belonging to residents abroad who enter the country to reside permanently, and to Brazilians returning to the country from abroad after residing there for more than 1 year.<br/><br/>Samples with No Commercial Value<br/>To qualify for this exemption, the item must fall under the definition of a sample with no commercial value, which refers to any goods imported under this condition for the purpose of demonstrating their characteristics, devoid of any commercial value. This may be due to the absence of value because of its quantity, weight, volume, or other presentation conditions, or because its value has been removed through physical operations to prevent its commercialization.<br/><br/>Books, Newspapers, and Periodicals <br/>Importation of books, newspapers, and periodicals, as well as paper intended for their printing, is granted immunity from the Import Tax.  <br/>To qualify for this immunity, the item must fall within the definition ofa book as stated in Article 2 of Law No 10,753/2003, which established the National Book Policy.",
    法律法规: "Regulations",
    法律法规说明:
      "Relevant regulations include:  <br/>- Ministry of Finance Ordinance No. 156, dated June 24, 1999  <br/>- Normative Instruction No. 1737, dated September 15, 2017  <br/>- COANA Ordinance No. 81, dated October 17, 2017  <br/>- Ministry of Finance Ordinance No. 612, dated June 29, 2023  <br/>- Normative Instruction RFB No. 2146, dated June 29, 2023  <br/>- COANA Ordinance No. 130, dated July 25, 2023",
    违禁物品: "Prohibited Items",
    违禁物品说明:
      "-Items Requiring Import Licensing (LI)  <br/>- Alcoholic beverages  <br/>- Cigarettes, cigars, and tobacco products  <br/>- Currency (cash)  <br/>- Wildlife animals and plants  <br/>- Used or refurbished materials (excluding personal use items)  <br/>- Firearms and ammunition  <br/>- Antiques and works of art  <br/>- Counterfeit products  <br/>- Flammable or hazardous materials  <br/>- Diamonds (HS 7102), precious and semi-precious stones, and jewelry  <br/>- Narcotics (illegal drugs)  <br/>- Chemical materials  <br/>- Gaming materials  <br/>- Human remains, including ashes  <br/>- Other goods whose transport is prohibited by international civil aviation regulations.",
  },
  请输入物品类型: "Please enter the item type",
  禁止运输货物清单: "Prohibited Goods List",
  运输限制: "Transportation Restrictions",
  "重量: 最大允许为30kg": "Weight: The maximum allowed is 30kg",
  "高度: 允许包裹高度在1到120cm之间": "Height: Packages allowed between 1 and 120cm",
  "宽度: 允许包裹宽度在1到120cm之间": "Width: Packages allowed between 1 and 120cm",
  "长度: 允许包裹长度在1到120cm之间": "Length: Packages allowed between 1 and 120cm",
  三边之和不得超过240厘米: "The total of the three sides must not exceed 240 cm",
  生物材料样本: "Biological material samples",
  已死亡动物: "Deceased animals",
  武器和军事装备: "Weapons and military equipment",
  "香烟、烟草制品及类似产品": "Cigarettes, tobacco products, and similar items",
  腐蚀性物质: "Corrosive substances",
  活生物: "Live organisms",
  现金: "Cash",
  法律禁止的毒品: "Legally prohibited drugs",
  爆炸物: "Explosives",
  珠宝和贵重石: "Jewelry and precious stones",
  液体: "Liquids",
  放射性物质: "Radioactive materials",
  药物: "Pharmaceuticals",
  危害国家安全的物品: "Items harmful to national security",
  鸟蛋: "Bird eggs",
  种子: "Seeds",
  活植物: "Live plants",
  各类危险品: "Various hazardous materials",
  尸体: "Corpses",
  对邮政服务的风险: "Risks to postal services",
  气雾剂: "Aerosols",
  易燃固体: "Flammable solids",
  "易腐烂、易变质、有异味、令人作呕和有害的物质": "Perishable, foul-smelling, nauseating, and harmful substances",
  锂离子电池和电池: "Lithium-ion batteries and cells",
  "压缩气体、液化气体或溶解在压力下的气体": "Compressed gases, liquefied gases, or gases dissolved under pressure",
  艺术品: "Artworks",
  氧化剂和有机过氧化物: "Oxidizers and organic peroxides",
  有毒物质和感染性物质: "Toxic and infectious substances",
  请输入: "Enter valid contents",
  下载: "download",
  "未获取到CT-E信息": "CT-E information not obtained",
  请输入CPF: "Please enter CPF",
  长度为11位: "Length is 11 digits",
  请输入CNPJ: "Please enter CNPJ",
  长度为14位: "Length is 14 digits",
  "CT-E 下载": "Download CT-E",
  输入的CPF不正确: "The entered CPF is incorrect",
  输入的CNPJ不正确: "The entered CNPJ is incorrect",
  全名: "Full Name",
  电子邮箱: "Email",
  收货地址: "Collection Address",
  产品类型: "Product Type",
  每月平均订单数量: "Average Order Quantity per Month",
  网站链接: "Website URL",
  推荐码: "Referral code",
  仅支持数字和字母: "Only numbers and letters",
  备注: "Notes",
  请选择省市区: "Please select state/city/district",
  "我们为整个巴西提供配送服务，立刻送达！": "We deliver to all of Brazil in no time! ",
  "想让 J&T 成为您电商的配送合作伙伴吗？ 请填写下面的表格，我们将尽快与您联系！":
    "Want to have J&T as your e-commerce delivery partner? Fill out the form below and we will contact you as soon as possible! ",
  "我们已经收到您的信息填报，将尽快与您取得联系！": "We have received your information submission and will contact you as soon as possible! ",
  "登录之后才能操作！": "Please perform the operation after logging in！",
  限制100字符以内: "Limit to 100 characters",
  "0-99999999之间的数字": "Only numbers between 0 and 99999999 are allowed",
  限制30字符以内: "Limit to 30 characters",
  限制200字符以内: "Limit to 200 characters",
  限制500字符以内: "Limit to 500 characters",
  "我想通过 WhatsApp 接收有关我的订单的最新信息": "I would like to receive updates about my order via WhatsApp.",
  我同意接收实时讯息和促销活动: "I agree to receive real-time messages and promotions.",
  修改密码: "Change password",
  最喜欢的网点: "Favorite site",
  请输入旧密码: "Please enter old password",
  请输入新密码: "Please enter new password",
  "密码必须包含大小写字母，数字及特殊字母其中三种，位数限制8-20位":
    "Please ensure your password is 8-20 characters long and contains at least three of the following: uppercase letters, lowercase letters, numbers, and special characters.",
  确认更改: "Confirm changes",
  "修改成功，请重新登录": "Changes were successful, please log in again",
  网点更新成功: "Update successful",
  选择最喜欢的网点: "Choose your favorite outlet",
  地址管理: "Address Book",
  新增: "Add",
  删除: "Delete",
  编辑: "Edit",
  查询姓名: "Search Name",
  "查询CPF/CNPJ": "Search CPF/CNPJ",
  新增地址簿: "Add Address Book",
  保存: "Save",
  取消: "Cancel",
  编辑地址簿: "Edit Address Book",
  未查询到数据: "No Data Found",
  "请输入CPF/CNPJ": "Please Enter CPF/CNPJ",
  请输入电子邮箱: "Please Enter Email",
  请输入邮政编码: "Please Enter Postal Code",
  "请输入州/市/区": "Please Enter State/City/District",
  "查询到相关地址信息，确认是否自动补充": "Address Information Found, Confirm to Auto-fill",
  温馨提示: "Friendly Reminder",
  是: "Yes",
  否: "No",
  请确认是否删除: "Confirm Deletion?",
  保留: "Keep",
  "州/市/区": "State/City/District",
  邮政编码: "Postal Code",
  请求成功: "successfully",
  保存到地址簿: "Save to address book",
  CPF或CNPJ已存在: "CPF or CNPJ already exists",
  长宽高总和不可超过240CM: "The sum of length, width, and height must not exceed 240 cm",
  输入需大于1: "Input must be greater than 1",
  公司名称: "Company Name",
  查件: "Place Order Now",
  客户: "Customers",
  服务支持: "Customer Support",
  B2C服务: "B2C",
  C2C服务: "C2C",
  CBT服务: "CBT",
  联系我们: "Contact Us",
  客户案例: "Customer Cases",
  客户专享: "Exclusive Benefits",
  企业文化: "Corporate Culture",
  发展历史: "Company History",
  订单反馈: "Order Feedback",
  环保反馈: "Sustainability",
  成为司机: "Become a Driver",
  招聘信息: "Careers",
  服务网点: "Service Locations",
  寄件单号列表: "Shipping tracking number list",
  收件单号列表: "Receiving tracking number list",
  请对您遇到的问题进行描述: "Please describe the problem you are experiencing",
  "如果需要查询详细轨迹，请输入CPF/CNPJ": "If you need to query detailed tracks, please enter CPF/CNPJ",
  "请输入运单号、发票密钥或客户订单号，使用逗号或分号分隔，最多可输入30个，且不支持混合查询":
    "Enter waybill no., invoice key, or order no., separated by commas/semicolons, max 30. No mixed queries.",
  "对不起，没有查询到相关轨迹，请核实": "Sorry, no relevant tracking information was found. Please verify.",
  "此为巴西本地数据，截止日期为01/12/2024": "Brazil local data, as of 12/01/2024",
  "相关信息，将通过邮件发送给您。": "The relevant information will be sent to you via email.",
  下载集成手册: "Download Manual",
  使用物品申明创建订单: "Create order with item declaration",
  点击下载表格模版: "Click to download table template",
  点击上传表格: "Click to upload table",
  使用发票创建订单: "Create order with invoice",
  批量选择XML发票文件: "select XML invoice files",
  每次最多可上传30条数据: "30 items can be uploaded per batch",
  文件解析失败: "File parsing failed",
  文件解析成功: "File parsed successfully",
  查看详情: "View details",
  批量导入: "Bulk import",
  XML文件解析失败: "XML file parsing failed",
  客户订单编号: "Customer order number",
  操作: "Action",
  上传: "Upload",
  上传成功: "Upload Successful",
  上传失败: "Upload Failed",
  状态: "Status",
  选择网点: "Select Service Point",
  网点名称: "Service Point Name",
  "仅勾选的订单会被下单，未勾选的订单将被移除，请确认。":
    "Only selected orders will be processed; unselected orders will be removed. Please confirm.",
  重新上传: "Re-upload",
  下单: "Order",
  暂无数据: "No data",
  "文件上传中...": "Uploading files... ({count}selected)",
  请选择订单: "Please select the orders",
  成为VIP: "Join VIP",
  "无论是小型还是中型企业家，您都应该拥有一个能够增强您业务的系统":
    "Whether you're a small or medium-sized entrepreneur, you should have a system that enhances your business",
  "更快、更高效的运输": "Faster and more efficient shipping",
  节省时间并赢得客户: "Save time and win more customers",
  完全自主: "Fully autonomous",
  "轻松、无复杂性地管理您的订单": "Manage your orders with ease—no complexity",
  智能控制: "Smart control",
  "查看您的销售情况、跟踪发货并优化您的结果": "Monitor your sales, track shipments, and optimize your results",
  什么是VIP: "What is VIP",
  "VIP系统是一款专为中小型企业主开发的平台，专注于简化订单与销售管理。 它提供以下功能：":
    "VIP is a platform specifically designed for small and medium-sized business owners, focused on simplifying order and sales management. It offers the following features:",
  高效管理: "Efficient Management",
  一站式全面掌控所有订单: "End-to-end control of all orders in one place",
  快速定制化发货: "Fast & Customized Shipping",
  "优化流程，精准满足客户需求": "Streamlined processes to precisely meet customer needs",
  自主管理权限: "Autonomous Permission Management",
  "简洁实用的工具，全程跟踪从下单到交付的每个环节": "Simple yet powerful tools to track every step from order to delivery",
  数据报告与分析: "Data Reporting & Analytics",
  "直观查看业务表现，助力战略决策": "Gain clear insights into business performance to support strategic decisions",
  VIP提供哪些服务: "What services does VIP provide",
  存储数据: "Data storage",
  系统注册: "System registration",
  系统: "System management",
  管理已发送的订单: "Managing shipped orders",
  运输类型: "Shipping types",
  权限分配: "Permission allocation",
  运费报价: "Freight quotes",
  "立即联系我们，迈出成功的下一步！": "Contact us now and take the next step toward success!",
  成为客户: "Become a client",
  售后管理: "After-sales Service",
  问题反馈: "Report Issue",
  查询: "Inquiry",
  输入运单号: "Enter Tracking Number",
  提交日期: "Submission Date",
  问题描述: "Issue Description",
  处理结果: "Resolution Result",
  请输入问题描述: "Please enter issue description",
  提交: "Submit",
  查看问题: "View Issue",
  处理中: "In Progress",
  已完结: "Completed",
  "Come on Join Us！": "Come on Join Us！",
  请支付: "Please pay",
  请选择支付方式: "Please select payment method",
  Pix支付: "Pix payment",
  信用卡: "Credit card",
  "剩余时间：x秒": "Remaining time: {count} seconds",
  使用扫码支付: "Scan QR code to pay",
  复制二维码code: "Copy QR code",
  完成支付: "Complete payment",
  请填写支付信息: "Please fill in payment information",
  卡号: "Card number",
  持卡人姓名: "Cardholder name",
  CVV码: "CVV code",
  "有效期MM/YYYY": "Expiry date MM/YYYY",
  选择日期: "Select date",
  完成付款: "Complete payment",
  开始日期: "Start date",
  结束日期: "End date",
  输入收件人姓名: "Enter recipient's name",
  支付状态: "Payment status",
  待支付: "Pending payment",
  已支付: "Paid",
  信用卡预授权成功: "Credit card pre-authorization successful",
  信用卡授权成功: "Credit card authorization successful",
  待客户寄件: "Awaiting customer shipment",
  附件下载: "Download attachment",
  支付: "Payment",
  取消订单: "Cancel Order",
  取消订单您需要知晓: "What you need to know when canceling an order:",
  "取消后，订单将无法寄出。": "After cancellation, the order cannot be shipped.",
  使用Pix支付: "Payment via Pix",
  退款处理时间最长为7个工作日: "Refunds may take up to 7 business days to process.",
  退款账户必须与付款时使用的账户姓名一致: "The refund account name must match the payer's name.",
  信用卡支付: "Credit Card Payment",
  将实时的取消授权支付: "The payment authorization will be canceled immediately.",
  二维码已过期: "QR Code Expired",
  复制成功: "Copied successfully",
  "支付失败，如您确认完成支付请重新点击完成支付，获取支付状态，如有疑问请联系：客服":
    "Payment failed. If you confirm that the payment is completed, please click again to complete the payment to obtain the payment status. If you have any questions, please contact: Customer Service",
  请输入卡号: "Please enter the card number",
  请输入CVV码: "Please enter the CVV code",
  请选择日期: "Please select the date",
  输入需大于0: "Must be > 0",
  有效期至: "Valid until",
  快过期: "Expiring soon",
  去使用: "Use now",
  我的优惠券: "My coupons",
  "还没有优惠券哦，快去领取吧～": "You don't have any coupons yet. Claim one now!",
  优惠信息: "Offer details",
  优惠券编码: "Coupon code",
  优惠券金额: "Coupon amount",
  具体费用以实际网点为准: "Final costs are subject to confirmation at the physical store.",
  选择优惠券: "Select coupon",
  活动描述: "Promotion description",
  活动时间: "Campaign duration",
  立即领取: "Claim now",
  "领取成功！优惠券已存入您的账户，快去使用吧~": "Claimed successfully! The coupon has been added to your account. Go use it now!",
  热门活动: "Popular Activities",
  打卡得: "Earn ",
  胡萝卜: "carrots",
  "点击可喂食MaoMao～": "Click to feed MaoMao~",
  去试试: "Try it",
  寄快递: "Send Parcel",
  批量寄: "Batch Shipping",
  运单查询: "Tracking Number Lookup",
  我的资料: "My Profile",
  "MaoMao Pet": "MaoMao Pet",
  "MaoMao Game": "MaoMao Game",
  请输入优惠券名称: "Please enter the coupon name",
  优惠券已关联活动无法编辑或删除: "This coupon is linked to an activity and cannot be edited or deleted",
  "是否确认修改?": "Confirm changes?",
  优惠券名称已存在: "Coupon name already exists",
  请输入活动名称: "Please enter the activity name",
  "请输入1~99的数值": "Please enter a value between 1 and 99",
  "最大数值为7位整数+2位小数,最小值为1": "Maximum value: 7-digit integer + 2 decimal places; Minimum value: 1",
  请选择优惠券: "Please select a coupon",
  领取数: "Claimed count",
  核销数: "Redeemed count",
  未核销数: "Unredeemed count",
  活动进行中或已结束不可删除: "Cannot delete: Activity is in progress or has ended",
  活动进行中或已结束不可编辑: "Cannot edit: Activity is in progress or has ended",
  相关活动名称: "Related activity name",
  待核销: "Pending redemption",
  已核销: "Redeemed",
  优惠券使用明细导出: "Coupon usage details export",
  "暂无活动，尽情期待~": "Coming soon! Watch this space for upcoming activities.",
  工作日: "Workday",
  休息日: "Rest day",
  更多操作: "More Actions",
  注销账号: "Delete Account",
  注销协议: "Account Deletion Agreement",
  重要提醒: "Important Notice",
  "您是否确定注销账号并同意放弃账号绑定的相关数据及资产？确定后您的账户会立即完成注销。":
    "Are you sure you want to delete your account and agree to relinquish all associated data and assets linked to it? Once confirmed, your account will be permanently closed immediately.",
  "我已阅读并同意《注销协议》": "I have read and agree to the Account Deletion Agreement",
  下一步: "Next",
  是否确定注销账号: "Are you sure you want to delete your account?",
  "您的账号在注销后将无法访问、无法恢复并永久关闭": "After deletion, your account will be inaccessible, unrecoverable, and permanently closed.",
  预制面单无法使用优惠券: "Coupon unavailable for pre-waybill",
  预制面单号: "Pre-generated waybill number",
  操作指引: "Operational Guidelines",
  "填写条形码下面的编号哦~": "Fill in the number below the barcode.",
  控制您的隐私: "Control Your Privacy",
  "我们的网站使用cookie来改善导航。": "Our website uses cookies to improve navigation.",
  拒绝: "Decline",
  接受: "Accept",
  Cookie政策: " Cookie Policy",
  活动即将开始: "The activity is about to start.",
  "J&T Express巴西公司保留本次活动的最终解释权。": "J&T Express Brazil reserves the final right of interpretation for this activity.",
  "详见《优惠券活动通用条款》。": 'Please refer to the "General Terms and Conditions for Coupon Activities".',
  模版更新时间: "Template update time",
  订单: "Order",
  钱包: "Wallet",
  充值: "Top up",
  钱包流水: "Wallet transactions",
  科目: "Category",
  暂无交易记录: "No transaction record",
  金额设置: "Set amount",
  请输入充值金额: "Enter top-up amount",
  支付方式: "Payment method",
  取消付款: "Cancel payment",
  "输入范围1~2000": "Range: 1–2000",
  钱包支付: "Pay with wallet",
  交易后金额: "Amount after transaction",
  全部: "All",
  散单运单运费: "Single shipment freight",
  运费补差价: "Freight difference",
  钱包充值: "Wallet recharge",
  退运费: "Freight refund",
  订单取消: "Order cancellation",
  待寄件: "To be sent",
  已取件: "Picked up",
  已签收: "Delivered",
  已取消: "Cancelled",
  差额补收: "Additional charge",
  去支付: "Go to pay",
  运单轨迹: "Tracking",
  电子钱包: "E-wallet",
  使用钱包支付: "Pay with wallet",
  当前余额: "Current balance",
  支付失败: "Payment Failed",
  "余额不足, 请尽快充值": "Insufficient balance, please recharge soon",
  我的钱包: "My wallet",
  时间: "Time",
  交易金额: "Transaction amount",
  自定义金额: "Custom amount",
  运费差额补收: "Freight difference supplementary collection",
  已支付金额: "Paid amount",
  实际称重: "Actual weight",
  "余额不足，请尽快充值": "Insufficient balance, please recharge as soon as possible",
  "运费未结清，请结清后下单。": "The freight has not been settled. Please settle it before placing an order.",
  确认使用钱包余额进行支付: "Confirm to pay with wallet balance",
  公告: "Announcement",
  紧急公告: "Urgent announcement",
  上线公告: "Published announcement",
  系统公告: "System announcement",
  置顶: "Pin",
  必读: "Must-read",
  发布时间: "Release time",
  暂无公告: "No announcements",
  "请输入 1~100 的正整数": "Enter 1–100",
  "44位数字": "44 digits",
  最大3位数字: "Max 3 digits",
  "最大9999999.99的数字": "Max 9,999,999.99",
  NCM编码: "NCM Code",
  物品单价: "Unit Price",
  请输入物品单价: "Enter price",
  物品数量: "Quantity",
  请输入物品数量: "Enter quantity",
  物品总金额: "Total Amount",
  请输入物品总金额: "Enter total",
  "DC-e密钥": "DC-e Key",
  "请输入DC-e密钥": "Enter DC-e Key",
  序列号: "Serial No.",
  请输入序列号: "Enter Serial No.",
  金额: "Amount",
  请输入金额: "Enter amount",
  授权日期: "Auth Date",
  请选择授权日期: "Select date",
  "请选择DC-e": "Select DC-e",
  获取失败: "Fetch failed",
  "获取DC-e": "Get DC-e",
  获取: "Get",
  请输入NCM编码: "Please enter NCM code",
  物品总金额不能超过1000: "Item total amount cannot exceed 1000",
  "DC-e 获取成功": "DC-e fetched",
  发票信息: "Invoice Info",
  待获取: "Pending",
  优惠券: "Coupon",
  请输入有效字符: "Please enter valid characters.",
  成为我们的加盟商: "Become a Franchisee",
  成为我们的PUDO站点: "Become a Collection Point",
  批量支付: "Batch Payment",
  云仓: "Fulfilment",
  招采信息: "Procurement",
  JoinUs: {
    合作机会: "Partnership opportunity",
    您的店铺可以成为: "Your store can become a",
    极兔速递收集点: "J&T Collection Point",
    "并产生额外收入。": "and generate extra income.",
    零加盟费: "Zero joining fee",
    零固定成本: "Zero fixed cost",
    无需库存: "No inventory required",
    我想成为极免速递收集点: "I want to be a J&T Collection Point",
    "提案提交成功！": "Proposal submitted successfully!",
    "我们已收到您成为极兔速递加盟商的意向。我们的销售团队将在48小时内与您联系，介绍完整的业务计划。":
      "We have received your interest in becoming a J&T Express franchisee. Our sales team will contact you within 48 hours to present the complete business plan.",
    提交新提案: "Submit new proposal",
    "立即注册！": "Register now!",
    "填写您的详细信息，成为极兔速递收集点。": "Fill in your details and become a J&T Express collection point.",
    姓名: "Name",
    电子邮件: "Email",
    电话: "Phone",
    营业执照号: "Business ID",
    地址: "Address",
    邮编: "ZIP Code",
    城市: "City",
    州: "State",
    "您是否已经为其他网络工作？": "Do you already act as a point for other networks?",
    是: "Yes",
    否: "No",
    提交注册: "Submit registration",
    "标有 * 的字段为必填项": "Fields marked with * are required",
    成功合作伙伴: "Successful Partners",
    评价: "Testimonials",
    合作伙伴怎么说: "What our partners say",
    极兔速递加盟商和合作伙伴的真实体验: "Real experiences of J&T Express franchisees and partners",
    "为什么选择极兔？": "Why choose J&T?",
    巴西最大的私营物流网络之一: "One of the largest private logistics networks in Brazil",
    "极免速递是巴西最大的私营物流网络之一,提供强大的基础设施来满足业多和消费者需求":
      "J&T Express is one of the largest private logistics networks in Brazil, offering a robust and efficient infrastructure to meet business and consumer demands.",
    主要电商平台的全球战略合作伙伴: "Global strategic partner of major e-commerce platforms",
    "极兔速递是主要电商平台的全球战略合作伙伴,如Shopee和Mercado Livre,提供对广泛市场的访问和客户。":
      "J&T Express is a strategic partner of major e-commerce platformsglobally, such as Shopee and Mercado Livre, providing access to a wide range of markets and customers.",
    先进技术和持续培训推动您的业务: "Advanced technology and continuous training to boost your bpusiness",
    "极兔速递投资于先进技术,并为合作伙伴提供持续培训,帮助优化运营并提高生产力。":
      "J&T Express invests in advanced technology and offers continuouis training to its partners, helping to optimize operations and increase productivity.",
    独家商业机会: "Exclusive business opportunity",
    成为: "Become a",
    极兔速递: "J&T Express",
    加盟商: "franchisee",
    我想成为极免速递加盟商: "I want to be a J&T franchisee",
    "表达您的兴趣！": "Express your interest!",
    "填写表格并获取有关加盟的详细信息。": "Fill out the form and receive detailed information about the franchise.",
    提交提案: "Submit proposal",
    谁已经在极兔速递的推动下增长: "Who is already growing with J&T",
    "看看一些正在与我们共同构建历史的加盟商。": "See some franchises that are building their story with us.",
    我们的客户: "Our Clients",
    信任极兔速递进行物流运营的领先公司: "Leading companies that trust J&T Express for their logistics operations",
    我们的加盟商怎么说: "What our franchisees say",
    "为什么选择极兔速递？": "Why choose J&T Express?",
    经过验证的商业模式: "Proven business model",
    "在数千次日常运营中测试和验证的运营系统,具有明确定义的流程和尖端技术。":
      "Operational system tested and validated in thousands of daily opperations, with well-defined processes and cutting edge technology.",
    独家和受保护的领地: "Exclusive and protected territory",
    "通过区域独家权确保您的运营区域,在没有内部竞争的情况下最大化您的市场潜力。":
      "Secure your area of operation with territorial exclusivity, maximizing youmarket potential without internal competition.",
    技术和持续创新: "Technology and constant innovation",
    "访问专有管理系统、实时跟踪和优化运营的工具。":
      "Access to proprietary management systems, real-time tracking and tools that optimize your operation",
    "加入极兔革新您所在地区的物流格局。": "Join J&T and revolutionize the logistics landscape in your region.",
    "先到者,得更多。": "Those who arrive first, conquer more.",
    "注册已提交！": "Registration submitted!",
    "我们已收到您的信息。我们的团队将很快与您联系，继续您作为极兔速递收集点的注册。":
      "We have received your information. Our team will contact you soon to continue your registration as a J&T Express collection point.",
    提交新注册: "Submit new registration",
  },
  fulfill: {
    以仓为核重构巴西物流布局: "With the warehouse at the core, we have redesigned all logistics in Brazil",
    通过分布式智能云仓网络我们建立了下一代供应链示范实现:
      "Through a distributed and intelligent network of cloud warehouses, we have created a next-generation supply chain model that allows:",
    商品前置化: "Advanced product positioning",
    履约无缝化: "Uninterrupted order fulfillment",
    响应敏捷化: "Faster and more efficient responses",
    以仓库为中心我们重新设计了巴西的整个物流体系: "With warehouses at the center, we redesigned the entire logistics system in Brazil",
    通过分布式智能云仓网络我们创建了下一代供应链模型实现了:
      "Through a distributed intelligent cloud warehouse network, we created a next-generation supply chain model that enables:",
    产品的提前布局: "Advanced product placement",
    订单无间断履行: "Uninterrupted order fulfillment",
    更快速高效的响应: "Faster and more efficient responses",
    联系我们: "Contact us",
    填写表格并获取我们的仓储履约服务信息: "Fill out the form to receive information about our Fulfillment service",
    基础信息: "Basic information",
    公司名称必填: "* Company Name",
    CNPJCPF必填: "* CNPJ / CPF",
    联系人必填: "* Contact Person",
    电话必填: "* Phone Number",
    邮箱必填: "* Email",
    业务规模: "Business Scale",
    月订单量: "Monthly Order Volume",
    SKU数量: "SKU Quantity",
    需要的服务可多选: "Services Needed (Multiple choices)",
    仓储: "Warehousing",
    一件代发: "Drop shipping",
    退货处理: "Return handling",
    发送提案: "Send proposal",
    请输入公司名称: "Please enter company name",
    公司名称长度不能超过60字符: "Company name cannot exceed 60 characters",
    请输入CNPJCPF: "Please enter CNPJ/CPF",
    CNPJCPF格式不正确: "Invalid CNPJ/CPF format",
    请输入联系人: "Please enter contact person",
    联系人长度不能超过50字符: "Contact person cannot exceed 50 characters",
    请输入电话: "Please enter phone",
    电话格式不正确: "Invalid phone format",
    请输入邮箱: "Please enter email",
    邮箱格式不正确: "Invalid email format",
    标有星号的字段为必填项: "Fields marked with * are required",
    了解更多: "Learn more",
    联系邮箱: "Contact email",
    自研仓储管理系统: "Self-developed Warehouse Management System",
    自研仓储管理系统描述1:
      "We self-developed the warehouse management system, which digitizes the warehouse process based on customer attributes, business needs, and specific scenarios, achieving a refined, intelligent, and visualized system for warehouse services.",
    自研仓储管理系统描述2:
      "On this basis, we accurately forecast inventory needs, pre-arrange replenishment, thereby significantly improving order processing efficiency, while effectively avoiding stockouts and inventory buildup issues.",
    运营优势: "Operational Advantages",
    仓库网络: "Warehouse Network",
    仓库网络描述:
      "We enhance the global warehouse and last-mile logistics network, driving foreign trade sellers to expand globally and ensuring perfect integration of the global logistics network.",
    全国覆盖: "Complete national coverage",
    区域物流中心: "Regional logistics centers",
    优化分发: "Optimized distribution",
    自有终端: "Own Terminal",
    自有终端描述: "Delivery network present in 13 countries, with extensive coverage and comprehensive distribution services.",
    受控配送: "Controlled delivery",
    实时跟踪: "Real-time tracking",
    保证质量: "Guaranteed quality",
    集成存储和配送: "Integrated Storage and Distribution",
    集成存储和配送描述:
      "The warehouse is located in the J&T Logistics Center Park, supported by the order sorting center, allowing integrated and uninterrupted collection.",
    集成流程: "Integrated process",
    降低成本: "Cost reduction",
    更高效率: "Greater efficiency",
    完整的产品解决方案: "Complete Product Solution",
    完整的产品解决方案描述:
      "Focus on B2B and B2C, with integration between storage and distribution as the core. Through a diversified warehouse structure and professional last-mile delivery services, it offers a complete solution for cross-border supply chains (including main/trunk transport, customs clearance, storage, distribution, and return services).",
    定制服务: "Customized service",
    运营灵活性: "Operational flexibility",
    全面支持: "Total support",
    多平台管理: "Multi-platform Management",
    多平台管理描述:
      "Supports restocking of multiple stores, multiple countries, and multiple platforms / merchant warehouse / physical supermarket and store delivery, performing unified 2B2C inventory.",
    与Shopee和MercadoLivre等集成: "Integration with Shopee, Mercado Livre, and more",
    统一库存可见性: "Unified stock visibility",
    实时同步: "Real-time synchronization",
    运营质量: "Operational Quality",
    运营质量描述: "Through digital monitoring of operational quality, we offer comprehensive, high-efficiency, and high-quality services.",
    进出检查: "Entry and exit inspection",
    最低错误率: "Minimum error rates",
    详细质量报告: "Detailed quality reports",
    专业团队: "Specialized Team",
    专业团队描述:
      "Professional support team, proprietary and fully managed storage and distribution system, as well as local management team abroad, ensuring stable operations.",
    认证专业人员: "Certified professionals",
    持续培训: "Continuous training",
    客户专属支持: "Customer dedicated support",
    标准化服务: "Standardized Services",
    标准化仓储和配送服务: "STANDARDIZED WAREHOUSING AND DISTRIBUTION SERVICES",
    定制仓储服务: "CUSTOMIZED WAREHOUSE SERVICE",
    增值服务: "Value-added Services",
    头程服务: "First Mile Services",
    国内揽收服务: "Domestic collection service",
    空海运头程: "Air and sea first mile",
    多式联运: "Multimodal transport",
    仓内存储: "Internal Storage",
    入口接收: "Entry receipt",
    库存管理: "Inventory management",
    质量控制: "Quality control",
    交货时间监控: "Lead time monitoring",
    最终配送: "Final Delivery",
    订单生成: "Order generation",
    订单跟踪: "Order tracking",
    负载生成: "Load generation",
    平台仓库: "Platform Warehouse",
    电子商务平台集成: "E-commerce platform integration",
    统一供应链管理: "Unified supply chain management",
    类别仓库: "Category Warehouse",
    产品类型专业化: "Product type specialization",
    类别优化管理: "Category-optimized management",
    如服装鞋子电子产品美容产品等: "Such as clothing, shoes, electronics, beauty products, etc.",
    定制仓库: "Custom Warehouse",
    基于客户需求的定制解决方案: "Custom solutions based on customer needs",
    入库流程: "Entry Process",
    质量检查: "Quality inspection",
    二次标签: "Secondary labeling",
    外部分发: "External distribution",
    出库流程: "Exit Process",
    集成包装: "Integrated packaging",
    礼品包装: "Gift packaging",
    包装定制: "Packaging customization",
    促销管理: "Promotion management",
    售后和退货: "Post-sales and Returns",
    照片上传: "Photo upload",
    退货检查: "Return inspection",
    测试: "Testing",
    回收: "Recycling",
    视觉报告: "Visual Reports",
    名确认: "Signature confirmation",
    签名确认: "Signature confirmation",
    报告审核: "Report audit",
    发货认证: "Shipping certification",
    配送跟踪: "Delivery tracking",
    "加载失败，请刷新页面重试": "Loading failed, please refresh the page and try again",
  },
  homeRedesign: {
    "巴西全国，快速发货。": "Fast shipping,\nacross Brazil.",
    "我们通过智能运输解决方案简化您的物流，确保全国范围内快速且安全的服务。":
      "We simplify your logistics with smart shipping solutions, ensuring fast and secure service nationwide.",
    兑换优惠券: "Redeem Coupon",
    "优惠券自兑换之日起7天内有效。仅限个人寄件使用。优惠券不可转让，也不可兑换现金。":
      "Coupons are valid for 7 days from the redemption date. For personal shipments only. Coupons are personal, non-transferable, and cannot be exchanged for cash.",
    快速发货: "FAST SHIPPING",
    "覆盖全巴西！": "Across Brazil!",
    "我们通过智能配送解决方案，让物流更简单，为您提供快速、安全、覆盖巴西全境的配送服务。":
      "We simplify your logistics with smart shipping solutions, ensuring speed, safety, and full coverage across all regions of the country.",
    立即寄件: "Send Package",
    计算运费: "Calculate Shipping",
    我们的合作伙伴: "The biggest companies deliver with J&T Express",
    确保您享受运费折扣: "Secure a discount on your package shipping",
    "兑换您的优惠券。": "Redeem your shipping discount coupon.",
    每周优惠券: "Weekly Coupon",
    "R$9,90": "R$9.90",
    每周: "per week",
    立即领取: "Redeem",
    "优惠券在兑换后有效期为7天。仅限个人寄件使用。优惠券不可转让且不可兑换现金。":
      "Coupon valid for up to 7 days after redemption. Exclusive for shipments from individuals. Personal coupon, non-transferable and not redeemable for cash.",
    "包裹重量上限 30千克，单边最长120厘米，三边总和不超过240厘米。":
      "The package can weigh up to 30kg, with a maximum of 120cm per side, and the total sum of dimensions must not exceed 240cm.",
    发货地邮编: "Origin Postcode",
    目的地邮编: "Destination Postcode",
    高度: "Height",
    长度: "Length",
    宽度: "Width",
    重量: "Weight",
    产品申报价值: "Declared product value",
    重新计算: "Recalculate",
    发送包裹: "Send Package",
    "%天内送达": "Delivered in % day",
    "预计到达日期：%": "Estimated arrival: %",
    "开始配送，": "START DELIVERING,",
    开始赚钱: "START EARNING",
    "加入 J&T Express，全球领先物流企业之一，业务覆盖 14 个国家，工作灵活，福利完善，每天都有新机会。":
      "Join J&T Express, one of the largest global logistics companies, present in 14 countries, offering dynamic work, benefits, and daily opportunities.",
    立即注册: "REGISTER NOW",
    成为司机: "Become a Driver",
    "了解加入我们的福利。": "Discover the benefits of joining us.",
    成为驿站: "Become a Collection Point Partner",
    成为加盟商: "Become a Franchisee",
    了解更多: "Learn More",
    客流更高: "High customer flow",
    为门店带来更多销售: "Increased sales at establishments",
    额外收入: "Extra income",
    通过代收和取件获得收益: "With order receipt and collection",
    本地运营: "Local operation",
    拥有高交付量: "With high delivery volume",
    全面支持: "Full support",
    配备先进技术: "With advanced technology",
    "快速发货，覆盖全巴西。": "Fast shipping across Brazil.",
    领取优惠券: "Redeem coupon",
    成为送货员: "BECOME A DELIVERY DRIVER",
    "利用空闲时间配送，自由安排工作时间和工作量，灵活增加收入。":
      "Make deliveries in your free time and increase your income with flexibility, choosing when and how much you want to work.",
    "通过简单便捷的代收服务，为您的店铺带来更多客流，同时获得额外收益！":
      "Bring more traffic to your business with a simple and convenient service. And earn money from it!",
    查看更多: "See More",
    我们可以将您的包裹快速送往全巴西: "We ship all over Brazil, in a flash",
    巴西各市覆盖范围: "Coverage of municipalities across Brazil",
    全国覆盖: "Nationwide Coverage",
    覆盖城市: "COVERED\nCITIES",
    覆盖城市数量: "5,571",
    寄件点: "J&T\nPOINTS",
    寄件点数量: "+6,000",
    区域干线: "REGIONAL\nROUTES",
    区域干线数量: "+1,600",
    转运中心: "TRANSFER\nCENTRES",
    转运中心数量: "+50",
    轻松接入各大主流平台: "Integration with the leading platforms in the market",
    立即接入: "Integrate Now",
    "一站式物流、仓储及配送解决方案": "Services and Solutions",
    "助力企业提升效率，实现规模化发展": "Integrated logistics, warehousing and distribution solutions designed for efficiency and scale.",
    高标准运营保障: "Operational quality of solutions",
    高效快捷的末端配送: "Fast last-mile delivery",
    仓储配送一体化: "Integrated warehousing and distribution",
    电商一站式履约服务: "Fulfillment services for e-commerce businesses",
    跨境物流解决方案: "Cross-border logistics solutions",
    "关于J&T Express": "About J&T Express",
    "J&T Express是一家全球综合物流服务企业，其快递业务在东南亚和中国市场处于领先地位。公司成立于2015年，依托智能化基础设施和数字化物流网络，为客户提供一体化物流解决方案。":
      "J&T Express is a global logistics services company, with leading operations in express deliveries in Southeast Asia and China. Founded in 2015, the company offers integrated logistics solutions through intelligent infrastructure and a digital logistics network.",
    听听他们怎么说: "What they say about us",
    "“我们非常高兴能与J&T Express合作。在过去一年的合作中，极兔始终为我们提供优质服务，并快速响应、妥善解决各类需求。”":
      "“We are very happy with our partnership with J&T Express, which, in this one year of collaboration, has provided us with excellent service and swift solutions.”",
    "“能够加入一个既重视效率、又坚持品质的体系，让我感到非常欣慰。我们共同取得的成果令我十分满意！”":
      "“It is rewarding to be part of a structure that values speed without compromising quality. I am very pleased with the results we are achieving together!”",
    "“这次合作为我们带来了非常好的效果，店铺客流量明显增加。如今，我们已经成为当地中小企业便捷的寄件服务点。”":
      '"The partnership has been very interesting; store traffic has increased significantly. Today, we are the freight solution for small and medium entrepreneurs in our city.”',
    "“短短三个月，我们的货件量便显著增长。J&T Express不仅推动了我们的业务发展，也为客户带来了更多便利，让包裹寄递更加轻松高效。”":
      "“In just three months, the volume of goods has grown. J&T has strengthened our business and brought benefits to customers, who now enjoy more convenience and efficiency in sending their parcels.”",
    "我为成为一家快速成长和发展的运输公司的合作伙伴感到自豪。希望我们能不断进步，巩固这段合作关系！":
      "I am proud to be a partner of a transport company that is growing and developing rapidly. I hope we can continue to evolve, strengthening this partnership!",
    "付款快速且稳定，体现了诚信与合作精神。感谢J&T Express让我成为收货点，并感谢至今为止的服务支持。":
      "Payments are quick and regular, showing honesty and partnership. I thank J&T Express for allowing me to be a collection point and for the service received so far.",
    "我们的合作不断增长，大家都非常细心地满足我的需求，我想表达对这段合作的深深感激！":
      "Our partnership has only grown; everyone is very attentive to meet my needs. I would like to express my immense gratitude for this partnership!",
    "伊瓜苏 - 巴拉那州": "Foz do Iguaçu - PR",
    "圣保罗 - 圣保罗州": "São Paulo - SP",
    "克鲁斯达斯阿尔马斯 - 巴伊亚州": "Cruz das Almas - BA",
    "坎普格兰德 - 马托格罗索州": "Campo Grande - MS",
    "里约热内卢 - 里约热内卢州": "Rio de Janeiro - RJ",
    "苏扎诺 - 圣保罗州": "Suzano - SP",
    "弗兰卡 - 圣保罗州": "Franca - SP",
    常见问题: "Frequently Asked Questions",
    "什么是J&T Express？": "What is J&T Express?",
    "如何使用J&T Express递寄件？": "How can I send with J&T Express?",
    "如何成为J&T Express的合作伙伴或供应商？": "How to become a partner or supplier of J&T Express?",
    "如何查询J&T Express包裹的物流进度？": "How to track a package delivery with J&T Express?",
    "如何联系J&T Express客服？": "How to contact the J&T Express team?",
    "J&T快递巴西是一家物流公司，连接巴西各地的人们和企业，提供安全、便捷、高效的配送、电商、个人寄送、清关、仓储和履约解决方案。":
      "J&T Express Brazil is a logistics company that connects people and businesses across Brazil, offering solutions for deliveries, e-commerce, individual shipments, customs clearance, storage, and fulfilment with safety, convenience, and speed.",
    "您可以下载J&T Brazil应用程序（iOS，Android），访问J&T Express官方网站，或寻找最近的收件点，安全、便捷、快速地寄送包裹。成为VIP客户，享受更多折扣和服务。":
      "You can download the J&T Brazil app (iOS, Android), visit the official J&T Express website, or find the nearest collection point to send your packages safely, conveniently, and quickly. Become a VIP customer and enjoy more discounts and services.",
    "无论是成为J&T的合作司机、收货点、加盟商还是合作供应商，请通过官方渠道联系我们。我们的团队将指导您了解要求和后续步骤。":
      "Whether you want to become a J&T partner driver, collection point, franchisee, or supplier partner, contact us through the official channels. Our team will guide you on the requirements and next steps.",
    "通过官方网站或J&T Brazil应用，访问追踪页面，输入包裹的追踪码，实时查看配送状态。":
      "Via the official website or the J&T Brazil app, go to the tracking page, enter the package tracking code, and follow the delivery status in real time.",
    "访问J&T客服中心或通过以下方式联系我们：\n电子邮件 meajuda@jtexpress.com.br\nWhatsApp +55 11 91666-3866。":
      "Access the J&T Customer Service Centre or contact us via:\nEmail meajuda@jtexpress.com.br\nWhatsApp +55 11 91666-3866.",
    请输入快递单号: "Enter the tracking code",
    立即查询: "Track",
    我想成为送货员: "I want to be a delivery person",
    寄件: "Send",
    服务: "Services",
    合作伙伴: "Become a Partner",
    公司信息: "Institutional",
    帮助: "Support",
    优惠券: "Coupons",
    帮助中心: "Help Centre",
    成为供应商: "Become a Supplier",
    招采信息: "Procurement",
    全巴西配送: "National Deliveries",
    云仓服务: "Fulfilment",
    清关服务: "Customs Clearance",
    联系我们: "Contact Us",
    关于我们: "Who We Are",
    招聘: "Careers",
    ESG: "ESG",
    媒体联络: "Press",
    联系方式: "Contact",
    客服: "Support",
    投诉: "Complaints",
    采购: "procurement",
    创建账户: "Create Account",
    葡萄牙语: "Português",
    中文: "中文",
    英语: "English",
    "访问其他国家的J&T": "Visit other J&T",
    选择国家: "Choose the country",
    印度尼西亚: "Indonesia",
    越南: "Vietnam",
    马来西亚: "Malaysia",
    菲律宾: "Philippines",
    泰国: "Thailand",
    柬埔寨: "Cambodia",
    新加坡: "Singapore",
    中国大陆: "Chinese Mainland",
    "中国香港/澳门": "Hong Kong/Macau, China",
    阿联酋: "UAE",
    沙特阿拉伯: "Saudi Arabia",
    墨西哥: "Mexico",
    巴西: "Brazil",
    埃及: "Egypt",
    确认: "Confirm",
    "© 2026 J&T Express 巴西。保留所有权利。": "© 2026 J&T Express Brazil. All rights reserved.",
    隐私政策: "Privacy Policy",
    服务条款: "Terms of Service",
    Cookie政策: "Cookie Policy",
    "保留所有权利。": "All rights reserved.",
  },
};
